<template>
  <section 
    class="wysiwyg"
    v-html="content">
  </section>
</template>

<script>
export default {
  name: 'Wysiwyg',
  props: {
    content: {
      type: String,
      default: null
    }
  }
}
</script>